import React, { Component } from "react";
import api from "../api/AxiosAPI";
import Auth from "../api/Auth";
import { Menu, Button } from "semantic-ui-react";
import { history } from "./history";
import { User } from "../data-models/user";
import { Subnivel } from "../data-models/subnivel";
import { Grid, Row, Col } from "react-flexbox-grid";
import AgregarItem from "./AgregarItem";
import wiserContext from "../providers/wiserContext";
import LoadingOverlay from "react-loading-overlay-ts";

interface IProps {}

interface IState {
  status_message: string;
  selectedScreen: string;
  showAddItem: boolean;
  subniveles: Subnivel[];
  newSubnivelDescripcion: string;
  loading: boolean;
}

class Subniveles extends Component<IProps, IState> {
  static contextType = wiserContext;
  constructor(props: IProps) {
    super(props);
    this.state = {
      status_message: "",
      selectedScreen: "",
      showAddItem: false,
      subniveles: [],
      newSubnivelDescripcion: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.getAllSubniveles();
  }

  getAllSubniveles() {
    console.log("getting subniveles");
    let fetchSubniveles: Subnivel[];
    fetchSubniveles = [];
    this.setState({ loading: true });
    api({
      method: "get",
      url: "subniveles/GetAllSubniveles",
      headers: {
        Authorization: Auth.getToken(),
      },
    })
      .then((response) => {
        this.setState({ loading: false });
        console.log("response data");
        console.log(response.data);
        for (var i in response.data) {
          let subnivel = response.data[i];
          fetchSubniveles.push({
            id: subnivel.id,
            nombre: subnivel.nombre,
            descripcion: subnivel.descripcion,
          });
        }
        this.setState({
          subniveles: fetchSubniveles,
          status_message: "Data about all grupos received successfully.",
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
        if (error.response) {
          if (error.response.status == 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  }

  addSubnivel = (subnivel: Subnivel) => {
    const { nombre, descripcion } = subnivel;
    console.log("subnivel por agregar");
    console.log(subnivel);
    this.setState({ loading: true });
    api({
      method: "post",
      url: "subniveles/SaveSubnivel?nombre=" + nombre,
      data: { descripcion: descripcion },
      headers: { Authorization: Auth.getToken() },
    })
      .then((response) => {
        this.setState({ loading: false });
        console.log("subnivel saved successfully");
        this.setState({
          status_message: "Data about the user saved successfully.",
        });
        this.getAllSubniveles();
        this.setState({ showAddItem: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
        if (error.response) {
          if (error.response.status == 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  addNewSubnivel = () => {
    const { newSubnivelDescripcion } = this.state;
    let newSubnivel: Subnivel;
    newSubnivel = {
      nombre: this.generateNombre(newSubnivelDescripcion),
      descripcion: newSubnivelDescripcion,
    };
    this.addSubnivel(newSubnivel);
  };

  generateNombre = (descripcion: string) => {
    let nombre = descripcion.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    nombre = nombre.toLowerCase().replace(/ /g, "_");
    return nombre;
  };

  deleteSubnivel(subnivel: Subnivel) {
    const { id, nombre, descripcion } = subnivel;
    this.setState({ loading: true });
    api({
      method: "delete",
      url: "/subniveles/DeleteSubnivel?nombre=" + nombre,
      headers: { Authorization: Auth.getToken() },
    })
      .then((response) => {
        this.setState({ loading: false });
        this.setState({
          status_message: "Data about the subnivel deleted successfully.",
        });
        this.getAllSubniveles();
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error.response) {
          if (error.response.status == 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  }

  generateAgregarItem = () => {
    const { showAddItem } = this.state;
    let a;
    if (showAddItem) {
      a = (
        <Grid style={{ marginTop: 20 }} fluid>
          <Row>
            <Col xs={6} md={3}>
              <form className="ui form">
                <div className="one fields">
                  <div className="field">
                    <input
                      onChange={(e) =>
                        this.setState({
                          newSubnivelDescripcion: e.target.value,
                        })
                      }
                      type="text"
                      placeholder="descripcion"
                    ></input>
                  </div>
                </div>
              </form>
            </Col>
            <Col xs={6} md={3}>
              <Button
                className="ui primary button"
                onClick={() => this.addNewSubnivel()}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Grid>
      );
    }

    return a;
  };

  render() {
    const { subniveles, loading } = this.state;
    const agregarItem = this.generateAgregarItem();
    return (
      <LoadingOverlay active={loading} spinner text="Cargando...">
        <div>
          <Button
            onClick={() =>
              this.setState({ showAddItem: !this.state.showAddItem })
            }
            className="ui primary button"
          >
            Agregar Subnivel
          </Button>
          {agregarItem}
          <Grid style={{ marginTop: 20 }} fluid>
            {subniveles.map((subnivel) => (
              <Row key={subnivel.id}>
                <Col xs={6} md={7}>
                  {subnivel.descripcion}
                </Col>
                <Col xs={6} md={3}>
                  <Button
                    className="ui red"
                    onClick={() => this.deleteSubnivel(subnivel)}
                  >
                    Eliminar
                  </Button>
                </Col>
              </Row>
            ))}
          </Grid>
        </div>
      </LoadingOverlay>
    );
  }
}

export default Subniveles;
